import { render, staticRenderFns } from "./AccordionToggle.vue?vue&type=template&id=f36083a6&functional=true"
import script from "./AccordionToggle.vue?vue&type=script&lang=js"
export * from "./AccordionToggle.vue?vue&type=script&lang=js"
import style0 from "./AccordionToggle.vue?vue&type=style&index=0&id=f36083a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports